module.exports = __webpack_public_path__ + "static/media/truste.180281dc.jpg";